import React, { Component } from 'react'
import { Box, Flex } from 'grid-styled'
import { withRouter } from 'react-router'

import Hide from '../../../../styles/utilities/Hide'
import LogoPipe from '../../../elements/Icon/logoPipe'
import colors from '../../../../styles/settings/colors'
import Button from '../../../elements/Button'

import { ListItem, LineTextContainer, LineText } from './styles'

class OrderRequestItem extends Component {
  getStatusColor = status => {
    switch (status) {
      case 'ENTREGUE':
        return { green: true }
      case 'DEVOLVIDO':
        return { red: true }
      case 'CANCELADO':
        return { red: true }
      case '': // Erro no pedido
        return { red: true }

      default:
        return null
    }
  }

  buttonCredit = () => {
    const { accountId, history } = this.props

    return (
      <Button
        text="Efetuar Recarga"
        onClick={() => history.push(`/minha-veloe/${accountId}/editar-dados/cartao?path=track`)}
        loading={false}
      />
    )
  }

  buttonActivate = () => {
    const { history } = this.props
    return (
      <Button
        onClick={() => history.push('/identificadores/ativacao')}
        text="Ativar Veloetag"
        loading={false}
      />
    )
  }

  renderButtonByStatus = (order, history) => {
    const { type } = this.props
    switch (order.status) {
      case 'ENTREGUE':
        if (type === 'pre') {
          if (order.paymentStatus === 'Pagamento Aprovado') {
            return this.buttonActivate()
          }
          return this.buttonCredit()
        } else {
          return this.buttonActivate()
        }
      case 'DEVOLVIDO':
        return (
          <Button
            buttonType="whiteNavyBlue"
            onClick={() => history.push(`acompanhar-pedido/${order.number}`)}
            loading={false}
            text="Rastrear pedido"
          />
        )
      case 'CANCELADO':
        return <Button disabled loading={false} text="Rastrear pedido" />

      case 'EXTRAVIADO':
        return (
          <Button
            buttonType="whiteNavyBlue"
            onClick={() => history.push(`acompanhar-pedido/${order.number}`)}
            loading={false}
            text="Rastrear pedido"
          />
        )

      case 'ENVIADO':
        return (
          <Button
            buttonType="whiteNavyBlue"
            onClick={() => history.push(`acompanhar-pedido/${order.number}`)}
            loading={false}
            text="Rastrear pedido"
          />
        )

      case 'SEPARACAO':
        return (
          <Button
            buttonType="whiteNavyBlue"
            onClick={() => history.push(`acompanhar-pedido/${order.number}`)}
            loading={false}
            text="Rastrear pedido"
          />
        )

      case 'TRANSPORTE':
        return (
          <Button
            buttonType="whiteNavyBlue"
            onClick={() => history.push(`acompanhar-pedido/${order.number}`)}
            loading={false}
            text="Rastrear pedido"
          />
        )

      default:
        return <Button disabled loading={false} text="Rastrear pedido" />
    }
  }

  render() {
    const { order, history, match } = this.props
    return (
      <ListItem>
        <Flex width={1} direction={['column', 'row']}>
          <Box width={[1 / 12]}>
            <LineTextContainer>
              <LogoPipe fill={colors.lightBlue} />
            </LineTextContainer>
          </Box>

          <Box width={[2 / 12]}>
            <LineTextContainer>
              <LineText bold>{order.number}</LineText>
            </LineTextContainer>
          </Box>

          <Hide at="small" width={[2 / 12]}>
            <LineTextContainer>
              <LineText>{order.date}</LineText>
            </LineTextContainer>
          </Hide>

          <Box width={[2 / 12]} mr={[10, 20]}>
            <LineTextContainer>
              <LineText capitalize {...this.getStatusColor(order.status)}>
                {order.status
                  ? order.status === 'ENVIADO' ? 'Separacao' : order.status.toLowerCase()
                  : 'Erro'}
              </LineText>
            </LineTextContainer>
          </Box>
          <Box width={[5 / 12]} mr={[10, 20]}>
            <LineTextContainer justifyContent="flex-end">
              {this.renderButtonByStatus(order, history, match)}
            </LineTextContainer>
          </Box>
        </Flex>
      </ListItem>
    )
  }
}

export default withRouter(OrderRequestItem)



// WEBPACK FOOTER //
// ./src/app/modules/OrdersRequestList/OrderRequestItem/index.js